.action-element {
    display: flex;
    align-items: center;
}

.action-element > button {
    padding-right: 0; /* This places the button 16px from the right border of the card */
}
